/*@ngInject*/
const UserImageRepository = function ($cacheFactory, baseRepository, currentUserModel) {

    angular.extend(this, baseRepository);

    this.updateUserImage = function (file, imageWidth, imageHeight) {
        let cacheKey = 'userProfile:' + currentUserModel.getCurrentUser().userId,
            url = '/rest/User/' + currentUserModel.getCurrentUser().userId + '/UserImage?maxWidth=' + imageWidth + '&maxHeight=' + imageHeight,
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            };

        formData.append('file', file);

        return this.post(url, formData, config).then(function (responseData) {
            $cacheFactory.get('loadProfileImageCache').remove(cacheKey);

            return responseData;
        });
    };
};

angular.module('umCore')
    .service('userImageRepository', UserImageRepository);
